import { CircularProgress, Flex, Text } from "@chakra-ui/react";
import React from "react";

const holdTight = {
  color: "#0E3665",
  fontSize: 18,
  fontFamily: "Nunito",
  fontWeight: 700,
  lineHeight: "32px",

  paddingTop: 4,
};

const loaderTagline = {
  color: "#0E3665",
  fontSize: 13,
  fontFamily: "Nunito",
  fontWeight: 400,
  lineHeight: "32px",
};

const LoadingScreen = ({ loadingText, loadingSubText }) => {
  return (
    <Flex flexDirection={"column"} justifyItems="center" alignItems="center">
      <CircularProgress isIndeterminate />
      <Text {...holdTight}>{loadingText}</Text>
      <Text {...loaderTagline}>{loadingSubText}</Text>
    </Flex>
  );
};

export default LoadingScreen;
